var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 93,
    viewBox: "0 0 90 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.51 21.6253L26.4516 14.9822L12.1191 22.1906L25.5319 28.9772L39.51 21.6253ZM45.4978 24.6684L59.1891 31.6322L44.9831 38.8209L31.5506 32.0231L45.4978 24.6684ZM63.7819 15.0834L77.8472 22.1906L65.2697 28.5553L51.5475 21.5831L63.7819 15.0834ZM57.7294 12.0206L45.0647 5.625L32.5406 11.9222L45.5878 18.5541L57.7294 12.0206ZM47.8294 66.9628V84.375L63.1688 76.6631L63.1519 59.2425L47.8294 66.9628ZM63.1463 53.1647L63.1294 35.9269L47.8294 43.5909V60.8344L63.1463 53.1647ZM81.5625 49.9331V67.4128L68.4788 73.9913L68.4703 56.5931L81.5625 49.9331ZM81.5625 43.8216V26.6934L68.4535 33.2606L68.4647 50.5322L81.5625 43.8216Z",
    fill: "#4DABCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4125 43.5938L32.0794 38.3597V60.9863C32.0794 60.9863 19.4428 33.8907 18.2812 31.4579C18.0344 31.1399 17.7153 30.8853 17.3503 30.7154C15.0778 29.5313 8.4375 26.1282 8.4375 26.1282V66.0938L17.6231 71.0438V50.1526C17.6231 50.1526 30.1247 74.3597 30.2512 74.6213C30.8931 76.0332 31.82 77.2972 32.9737 78.3338C34.7597 79.5235 42.4153 84.1641 42.4153 84.1641L42.4125 43.5938Z",
    fill: "#4D77CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_101",
    x: -4,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_101",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.0e4c28504887ef52d1667fa62356c673.svg";
export { ForwardRef as ReactComponent };